import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { PagedService } from '../paged.service';

//#region Models
import { BaseDataResponse, BaseResponse } from '../models/base.model';
import { PagedResponse } from '../models/paged.model';
import { SignIn, User } from './models/index';
//#endregion

import {
  ConfirmEmailRequest,
  IncludeRolesRequest,
  RemoveRolesRequest,
  PasswordResetRequest,
  ResetPasswordRequest,
  SignInRequest,
  SignInRefreshRequest,
  SignUpRequest,
  UserSearchRequest,
  UserUpdateRequest,
} from './requests/index';

const API_URL = `${environment.authApi}/User`;

@Injectable({
  providedIn: 'root',
})
export class UserService extends PagedService {
  constructor(protected override _httpClient: HttpClient) {
    super(_httpClient);
  }

  signIn(request: SignInRequest): Observable<BaseDataResponse<SignIn>> {
    return this._httpClient.post<BaseDataResponse<SignIn>>(
      `${API_URL}/SignIn`,
      request,
    );
  }

  refresh(request: SignInRefreshRequest): Observable<BaseDataResponse<SignIn>> {
    return this._httpClient.post<BaseDataResponse<SignIn>>(
      `${API_URL}/SignIn/Refresh`,
      request,
    );
  }

  signUp(request: SignUpRequest): Observable<BaseDataResponse<User>> {
    return this._httpClient.post<BaseDataResponse<User>>(
      `${API_URL}/SignUp`,
      request,
    );
  }

  confirmEmail(request: ConfirmEmailRequest): Observable<BaseResponse> {
    return this._httpClient.post<BaseResponse>(
      `${API_URL}/ConfirmEmail`,
      request,
    );
  }

  /**
   *Request temp account token via e-mail to reset the password
   */
  passwordReset(
    request: PasswordResetRequest,
  ): Observable<BaseDataResponse<string>> {
    return this._httpClient.post<BaseDataResponse<string>>(
      `${API_URL}/PasswordReset`,
      request,
    );
  }

  /**
   *Send temp account token and new password to be changed.
   */
  resetPassword(
    request: ResetPasswordRequest,
  ): Observable<BaseDataResponse<string>> {
    return this._httpClient.post<BaseDataResponse<string>>(
      `${API_URL}/ResetPassword`,
      request,
    );
  }

  includeRoles(request: IncludeRolesRequest): Observable<BaseResponse> {
    return this._httpClient.post<BaseResponse>(
      `${API_URL}/IncludeRoles`,
      request,
    );
  }

  removeRoles(request: RemoveRolesRequest): Observable<BaseResponse> {
    return this._httpClient.post<BaseResponse>(
      `${API_URL}/RemoveRoles`,
      request,
    );
  }

  getById(id: string): Observable<BaseDataResponse<User>> {
    return this._httpClient.get<BaseDataResponse<User>>(`${API_URL}/${id}`);
  }

  search(
    request: UserSearchRequest,
  ): Observable<BaseDataResponse<PagedResponse<User>>> {
    return this.getPaged(`${API_URL}/Search`, request);
  }

  update(request: UserUpdateRequest): Observable<BaseDataResponse<User>> {
    return this._httpClient.put<BaseDataResponse<User>>(API_URL, request);
  }
}
